<template>
  <v-layout column>
    <h3 class="font-weight-medium mb-4">Resources</h3>

    <v-layout v-if="!isResourcesFetched" column justify-center align-center class="mt-5">
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      <p class="subheading-1 mt-5 primary--text font-weight-bold">Retrieving Resources...</p>
    </v-layout>

    <v-simple-table v-else class="mt-3">
      <thead>
        <tr>
          <th class="text-left">Title</th>
          <th class="text-left">Added on</th>
          <th class="text-left">Type</th>
          <th class="text-center">Download</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in getResources" :key="item.url">
          <td>{{ item.title }}</td>
          <td>{{ item.addedOn | dateFormat }}</td>
          <td>
            <img src="../assets/pdf-ico.png">
          </td>
          <td class="text-center">
            <v-btn :href="item.url" target="_blank" small depressed class="dr">
              <v-icon small color="white">mdi-download</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-layout>
</template>

<style scoped>
.br {
  border-radius: 3px;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["isResourcesFetched", "getResources"])
  },
  methods: {
    ...mapActions(["fetchResources"])
  },
  created() {
    if (!this.isResourcesFetched) {
      this.fetchResources();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isResourcesFetched) return;
    return next();
  }
};
</script>